export default __webpack_public_path__ + "static/media/log.ae683a37.jpeg";